import type {
  GlobalStateCommandFactory,
  License,
} from 'components/GlobalState/GlobalStateModel';

interface SaveLicenseCommand {
  license: License;
}

export const saveLicense: GlobalStateCommandFactory<SaveLicenseCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.license.devices = command.license.devices;
      draft.license.ccu = command.license.ccu;
      draft.license.state = command.license.state;
      draft.license.validTo = command.license.validTo;
      draft.license.additionalFeatures = command.license.additionalFeatures;
    });
  };
